
const formatDuration = (ms) => {
    let seconds = Math.floor(Math.abs(ms) / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);
    minutes = minutes % 60;

    return ms < 0 ? `- ${hours}h ${minutes !== 0 ? minutes + 'min' : ''}` : `${hours}h ${minutes !== 0 ? minutes + 'min' : ''}`;
};

const formatDDMMYY = (date) => {
    return date.toLocaleDateString('de-de', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

const formatHHMM = (date) => {
    return date.toLocaleString('de-de', { hour: '2-digit', minute: '2-digit' });
};

const formatDDMM = (date) => {
    return date.toLocaleDateString('de-de', { day: '2-digit', month: '2-digit' });
};

const formatWeekDay = (date) => {
    return date.toLocaleDateString('de-de', { weekday: 'short' });
};

const formatYYYYMMDD = (date) => {
    return date.toISOString().split('T')[0]
}

// Pad a number to 2 digits
const pad = n => `${Math.floor(Math.abs(n))}`.padStart(2, '0');
// Get timezone offset in ISO format (+hh:mm or -hh:mm)
const getTimezoneOffset = date => {
    const tzOffset = -date.getTimezoneOffset();
    const diff = tzOffset >= 0 ? '+' : '-';
    return diff + pad(tzOffset / 60) + ':' + pad(tzOffset % 60);
};

const formatISOStringWithTimeZone = date => {
    return date.getFullYear() +
        '-' + pad(date.getMonth() + 1) +
        '-' + pad(date.getDate()) +
        'T' + pad(date.getHours()) +
        ':' + pad(date.getMinutes()) +
        ':' + pad(date.getSeconds()) +
        getTimezoneOffset(date);
};


export default {
    formatDuration,
    formatDDMMYY,
    formatHHMM,
    formatDDMM,
    formatWeekDay,
    formatYYYYMMDD,
    formatISOStringWithTimeZone,
}
